import request from '@utils/request';
import { ActionCreatorWithPayload, ActionCreator } from '../../types';

import { DeferredPaymentDetailsType } from '../types';

import {
  PAYMENT_DETAILS_FAILURE,
  PAYMENT_DETAILS_REQUEST,
  PAYMENT_DETAILS_SUCCESS,
} from './action-types';

import {
  PaymentDetailsSuccessAction,
  PaymentDetailsRequestAction,
  PaymentDetailsFailureAction,
  FetchPaymentDetailsType,
} from './types';

const getPaymentDetailsSuccess: ActionCreatorWithPayload<
  PaymentDetailsSuccessAction,
  DeferredPaymentDetailsType
> = (payload) => ({
  type: PAYMENT_DETAILS_SUCCESS,
  payload,
});

const getPaymentDetailsRequest: ActionCreator<PaymentDetailsRequestAction> = () => ({
  type: PAYMENT_DETAILS_REQUEST,
});

export const getPaymentDetailsFailure: ActionCreator<PaymentDetailsFailureAction> = () => ({
  type: PAYMENT_DETAILS_FAILURE,
});

export const fetchPaymentDetails: FetchPaymentDetailsType =
  ({ propertyId, orderNumber, moneyTransferQueueId }) =>
  (dispatch) => {
    dispatch(getPaymentDetailsRequest());

    return request
      .get(`${propertyId}/${orderNumber}/deferred-payments/${moneyTransferQueueId}/details`)
      .then(({ data }) => dispatch(getPaymentDetailsSuccess(data)))
      .catch(() => dispatch(getPaymentDetailsFailure()));
  };
